var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{staticClass:"rounded-full",class:_vm.size,attrs:{"src":`https://avatars.githubusercontent.com/${_vm.username}`}})
}
var staticRenderFns = []

export { render, staticRenderFns }